import request from "@/http";

const submitFeedBack=(data)=>{
    let { id_public_user_info,mid_table_remark_001,mid_table_remark_002, isloading=false, type_middle_app = 10001, type_inner_app = 1001, is_online = 0 } = data;
    return request.post({
        url: "duzikai_api_mgr_public_middle_table",
        data: {
            invoke_method: "public_insert_or_update_middle_table",
            id_public_user_info: id_public_user_info,
            mid_table_remark_001: mid_table_remark_001,
            mid_table_remark_002: mid_table_remark_002,
            type_middle_app: type_middle_app,
            type_inner_app: type_inner_app,
            is_online: is_online,
            pre_db_para_middle_table_name: "public_middle_table",
        },
        loading: {
            enabled: isloading
        }
    })
}

export default {
    submitFeedBack
}
